import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, catchError, throwError} from 'rxjs';
import {SearchPaginatedAirportResponse} from '../../model/airport';

@Injectable({
  providedIn: 'root'
})

export class AirportService {
  private resourcePath: string = 'dbov2/airport';
  
  constructor(private httpClient: HttpClient) {
  }

  searchPaginatedAirports(airportFilter: any): Observable<SearchPaginatedAirportResponse> {
    return this.httpClient
        .get<SearchPaginatedAirportResponse>(`${this.resourcePath}/search`, {params: airportFilter})
        .pipe(catchError(this.errorHandler));

  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(() => new Error(error.message || 'Server Error'));
  }
}
